const initialState = {
  k12Admins: [],
  caseloadCategories: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'STAFF_PROFILE/POPULATE_STAFF_PROFILE_LIST':
      return {
        ...state,
        k12Admins: action.k12Admins,
      };

    case 'STAFF_PROFILE/POPULATE_CASELOAD_CATEGORIES':
      return {
        ...state,
        caseloadCategories: action.caseloadCategories,
      };

    default:
      return state;
  }
};
